import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/effect-fade/effect-fade.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";

// import Swiper core and required modules
import SwiperCore, { EffectFade, Navigation, Pagination } from "swiper/core";
import banner1 from "views/ilearn/img/banner.png";

// install Swiper modules
SwiperCore.use([EffectFade, Navigation, Pagination]);

export default function App(props) {
  const addDefaultSrc = (ev) => {
    ev.target.src = banner1;
  };
  return (
    <>
      <Swiper
        spaceBetween={30}
        effect={"fade"}
        navigation={false}
        pagination={{
          clickable: true,
        }}
        className="mySwiper"
      >
        {props.courses.slice(0, 3).map((course,index) => (
          <SwiperSlide className="relative " key={index}>
            <img
              onError={addDefaultSrc}
              src={`http://localhost:3001/${course.c_cover_img_path}`}
              className="w-full maxh-396px object-fill"
              alt="banner-img "
            />

            <div className="inside-listing absolute w-1/3 text-left">
              <h1 className="text-black font-semibold sm-fsize16">
                {course.c_title || "The Course"}
              </h1>
              <p className="text262626 fsize18 text-left">
                {course.c_short_description || "this is short description"}
              </p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}
